<template>
  <div>
    <div class="feature_head">
      <div class="feature_head_tap">
        <div
          class="taps"
          v-for="(item, index) in taps"
          :key="index"
          :class="{ activetaps: item.active }"
          @click="changetaps(item.active)"
        >
          {{ item.text }}
          <div :class="{ activesanjiao: item.active }"></div>
        </div>
      </div>
    </div>
    <div class="feature_body">
      <div
        v-if="taps[0].active"
        style="width: 1054px; margin: 0 auto; font-size: 14px"
      >
        <p
          style="
            padding: 55px 0 26px 0;
            text-align: left;
            width: 945px;
            margin: 0 auto;
            letter-spacing: 1px;
          "
          class="czsc"
        >
          管理端根据期货公司岗位设置和人员配置提供用户管理、策略研发、策略管理三个模块。
        </p>
        <div v-for="(item, index) in fourmd" :key="index" class="fourmd">
          <div class="fmtitle">{{ item.title }}</div>
          <div class="smallul">{{ item.smallti }}</div>
          <div
            :style="{ background: 'url(' + item.img + ')no-repeat center' }"
            class="tubiao"
          ></div>
          <!-- <div class="zhedang">
            <vue-scroll :ops="ops">
              <p class="zdtext">{{ item.text }}</p>
            </vue-scroll>
          </div> -->
          <!-- <div class="jiantou"></div> -->
        </div>
      </div>
      <div v-if="taps[1].active" class="kehu">
        <p
          style="
            padding-top: 55px;
            text-align: left;
            font-size: 14px;
            line-height: 25px;
            width: 945px;
            margin: 0 auto;
          "
        >
          个人客户可通过用户使用端浏览策略、订阅策略，客户订阅的策略在云环境中运行。
        </p>
        <!-- <img
          src="../assets/img/cel1.jpg"
          alt=""
          style="margin-top: 25px; width: 644px; margin-right: 30px"
        />
        <img
          src="../assets/img/cel2.jpg"
          alt=""
          style="margin-top: 25px; width: 676px"
        /> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
          background: "rgb(171,185,226)",
        },
      },
      act: true,
      taps: [
        {
          text: "管理端",
          active: "",
        },
        {
          text: "用户使用端",
          active: "",
        },
      ],
      fourmd: [
        {
          title: "用户管理",
          img: require("../assets/img/a1.png"),
          text: "交易管理能够统一汇总、管理机构的多个交易通道，方便从公司层面整体上进行资金管理，可根据交易需要，为每位基金经理开设不同的交易员账号，把多个期货公司资金账号的实际资金分配给多个基金经理使用，优化资金配置，提高交易效率；可对每个交易员账户进行独立结算，并自动生成分析报告，提供包括净利润、交易胜率、收益率、回撤率、权益、资金使用率及期末持仓等数据，全面系统的展现每个交易员的交易详情；可对机构维度进行总资产分析报告，其中包含总权益、总盈亏、回撤率、总收益率、资金使用率及期末持仓等数据。",
          smallti:
            "交易管理人员可通过用户管理端开设账号，给策略研发人员、策略管理人员分配策略研发和策略管理的权限。给个人用户的交易账号分配权限，用户可使用交易账号登录用户使用端。",
        },
        {
          title: "策略研发",
          img: require("../assets/img/a2.png"),
          text: "风险管理针对交易所（大额报撤、频繁报撤、自成交、持仓限额、交易限额等）、交易通道（交易行为、资金监控、交易范围等）、交易员（交易频率、资金实时监控、交易范围、持仓限制等）设立了不同层级的风险控制指标，可实现事前、事中、事后全方位风险控制。通过风险计算引擎，在确保合规兼顾效率的前提下，提高资金使用率，降低各层级的交易风险，形成一套完整的风险控制体系。",
          smallti:
            "策略研发人员可通过策略研发端编写、回测交易策略，并支持将研发好的策略上传到策略管理端中。",
        },
        {
          title: "策略管理",
          img: require("../assets/img/a3.png"),
          text: "产品管理可对产品净值进行实时计算，方便产品管理人实时掌握净值变化情况；可对产品层面进行风险设置，根据合同设置不同类型风控，以满足监管要求和风险控制；可对产品层面进行资产分析，从而掌握产品的运行情况，分析产品产品收益情况。",
          smallti:
            "策略管理人员通过策略管理端运行/停止策略研发人员上传的策略;可以管理客户的订阅。",
        },
      ],
    };
  },
  methods: {
    changetaps(it) {
      if (it == false) {
        this.act = !this.act;
        this.taps[0].active = this.act;
        this.taps[1].active = !this.act;
      }
    },
  },
  created() {
    var ta = this.$route.query.fe;
    if (ta == 2) {
      this.act = false;
    } else {
      this.act = true;
    }

    this.taps[0].active = this.act;
    this.taps[1].active = !this.act;
  },
};
</script>
<style scoped>
.feature_head {
  height: 275px;
  background: url(../assets/img/xz-banner.jpg) no-repeat center;
  position: relative;
  border-bottom: 4px solid #0a3b95;
}
.feature_body {
  height: 522px;
  background: url(../assets/img/gn-bg.jpg) no-repeat center;
  color: #656565;
}
.feature_head_tap {
  width: 1054px;
  height: 61px;
  margin: 0 auto;
  padding-top: 214px;
}
.czsc {
  line-height: 25px;
}
.czsc a {
  color: #463ee7;
  text-decoration: underline;
}
.czsc a:visited {
  color: #463ee7;
}
.taps {
  height: 100%;
  width: 523px;
  text-align: center;
  line-height: 61px;
  background: #e6e6e6;
  position: relative;
  display: inline-block;
  color: #113f8a;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px 5px 0 0;
  margin: 0 2px;
  letter-spacing: 2px;
}
.activetaps {
  background: url(../assets/img/qh-1.png) no-repeat center;
  color: #fffffb;
}
.activesanjiao {
  width: 15px;
  height: 15px;

  position: absolute;
  background: url(../assets/img/sanjiao.png) no-repeat center;
  bottom: -13px;
  z-index: 999;
  left: 263px;
}
.kehu {
  width: 1400px;
  margin: 0 auto;
}
.fourmd {
  margin-right: 70px;
  height: 310px;
  width: 300px;
  border-radius: 10px;
  background: white;
  position: relative;
  display: inline-block;
}
.fourmd:last-child {
  margin-right: 0;
}
.tubiao {
  position: absolute;
  right: -3px;
  top: -8px;
  width: 119px;
  height: 97px;
}
.zhedang {
  background: rgba(66, 84, 124, 0.8);
  width: 100%;
  height: 100%;
  border-radius: 10px;
  z-index: 55555;
  position: absolute;
  color: white;
  text-align: justify;
  display: none;
}
.zdtext {
  text-indent: 2em;
  font-size: 14px;
  padding: 24px 0px 24px 19px;
  width: 260px;
  /* position: absolute;
  top: 10%;
  margin-top: -50px;
  left: 0;
  right: 0; */
  text-align: justify;
  line-height: 22px;
}
.jiantou {
  background: url(../assets/img/anniu.png) no-repeat center;
  width: 22px;
  height: 19px;
  position: absolute;
  right: 33px;
  bottom: 27px;
}
.fourmd:hover .zhedang {
  display: block;
}
.fmtitle {
  position: absolute;
  top: 80px;
  left: 33px;
  width: 227px;
  text-align: left;
  font-size: 17px;
  border-bottom: 1px solid #bcc5d3;
  font-weight: bold;
  line-height: 32px;
}
.smallli::before {
  content: "·";
}
.smallul {
  position: absolute;
  left: 33px;
  top: 120px;
  text-align: left;
  width: 227px;
  line-height: 30px;
  text-align: justify;
}
.smallul li {
  line-height: 27px;
}
</style>